import {
  type AnyPgColumn,
  boolean,
  integer,
  pgEnum,
  pgTable,
  text,
  timestamp,
  uniqueIndex,
  uuid,
  varchar,
} from "drizzle-orm/pg-core"
import { contacts } from "./contact"
import { estateGoalCategory } from "./estate-goal-category"

export const estatePhaseEnum = pgEnum("estate_phase_enum", ["PLANNING", "PROBATE", "SETTLED"])

// Purpose: Represents an individual's or family's estate plan, serving as the central hub for all related data.
export const estates = pgTable(
  "estate",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    estateName: varchar("estate_name", { length: 255 }).notNull(),
    description: text("description"),
    createdAt: timestamp("created_at").defaultNow().notNull(),
    // Note: For 'ON UPDATE CURRENT_TIMESTAMP' functionality in PostgreSQL,
    // a database trigger is required. This schema sets the timestamp on creation,
    // and application logic or a trigger should handle updates.
    updatedAt: timestamp("updated_at").defaultNow().notNull(),
    isActive: boolean("is_active").default(true),
    estatePhase: estatePhaseEnum("estate_phase").default("PLANNING").notNull(),
    testatorContactId: uuid("testator_contact_id").references((): AnyPgColumn => contacts.id, {
      onDelete: "restrict",
    }),
  },
  (table) => [uniqueIndex("estate_testator_contact_id_uq").on(table.testatorContactId)],
)

// Purpose: Stores the estate planning goals for an estate.
export const estateGoal = pgTable("estate_goal", {
  id: uuid("id").primaryKey().defaultRandom(),
  estateId: uuid("estate_id")
    .notNull()
    .references(() => estates.id, { onDelete: "cascade" }),
  goal: text("goal").notNull(),
  category: estateGoalCategory("category").notNull(),
  priority: integer("priority").default(0),
  estateNotes: text("estate_notes"),
  createdAt: timestamp("created_at").defaultNow().notNull(),
  updatedAt: timestamp("updated_at").defaultNow().notNull(),
})
